module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/KFsEOU/tc-custom/9781631953705.jpg?1736222097975",
      "alt": "This image is the cover for the book Timeless"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Timeless\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In this allegorical journey, a traveler sets out on an expedition to discover life‚Äôs greatest secret.")]), _c('p', [_c('br'), _c('br'), _vm._v("The nature of time is an age-old question that has been pondered by mankind for centuries, leading to many a quest for the illusive fountain of youth. What is time? How is it measured? Can we affect time? How can it be optimized for people to fulfill their life‚Äôs purpose? ")]), _c('p', [_c('br'), _c('br'), _vm._v("In Timeless, Kathy and Victor Brook blend elements of reality, fantasy, history, spirituality, and science to take readers on one traveler‚Äôs journey covering the four corners of the earth, armed with an unquenchable thirst for destiny‚Äôs call to understand the truth of human experience. Told in first-person narration, readers watch the traveler‚Äôs evolution as he discovers ancient artifacts and allows them to guide his journey and take him through lessons from ancient civilizations. Young and old alike hold their breath with the traveler at each stage of his journey as he moves closer to unveiling life‚Äôs greatest secret‚Äîand cascading through time.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kathy Brook\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Morgan James Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0